import { render, staticRenderFns } from "./NewUserWelcomePage.vue?vue&type=template&id=820c27c0&scoped=true"
import script from "./NewUserWelcomePage.vue?vue&type=script&lang=js"
export * from "./NewUserWelcomePage.vue?vue&type=script&lang=js"
import style0 from "./NewUserWelcomePage.vue?vue&type=style&index=0&id=820c27c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820c27c0",
  null
  
)

export default component.exports